import { DocsCallout, DocsSteps } from "../components"

Start with the user-visible state first, then inspect operational details only when needed.

<DocsSteps>
  <li>Check whether the site has linked provider accounts.</li>
  <li>Confirm tracking mappings exist for the event the campaign should optimize toward.</li>
  <li>Open the campaign channel detail page for launch state, sync state, and provider entities.</li>
  <li>Use job history or ops events for provider/API failures.</li>
</DocsSteps>

<DocsCallout title="Validation is not an ops error">
  Known user-correctable validation errors should be visible in the UI and should not flood
  operational telemetry.
</DocsCallout>

Provider configuration failures, expired credentials, missing account access, and API permission
issues should be fixed directly rather than papered over in launch code.
